import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        stepper: {
            width: '100%',
            justifyContent: 'center',
            gap: remCalc(0),
            margin: '0 auto',
        },
        step: {
            gap: remCalc(0),
        },
        flexContainer: {
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: remCalc(14),
            minWidth: [remCalc(50), remCalc(50), remCalc(50), remCalc(100)],
        },
        stepIndicator: {
            color: 'text.inverse',
            border: 'unset',
            textStyle: 'body-large',
            backgroundColor: 'background.grey',
        },
        stepNumber: {
            fontSize: remCalc(18),
            height: remCalc(18),
        },
        flexLabel: {
            display: {base: 'none', md: 'flex'},
            gap: remCalc(14),
            direction: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        },
        stepTitle: {
            textStyle: 'body-medium',
            fontWeight: 'normal',
        },
        stepDescription: {
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        stepSeparator: {
            gap: remCalc(10),
            width: {base: '100%', sm: '100%', md: remCalc(96), lg: remCalc(313)},
            borderRadius: remCalc(4),
            height: remCalc(4),
            marginTop: [remCalc(14), remCalc(14), remCalc(14), remCalc(16)],
            alignSelf: 'flex-start',
            marginInlineStart: 0,
            backgroundColor: 'background.grey',
        },
    },
}
